<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="账号">
              <j-input placeholder="设备名称/位号" v-model="queryParam.username" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="位置">
              <!-- <j-input placeholder="提升泵房" v-model="queryParam.position" /> -->
              <a-select placeholder="提升泵房" v-model="queryParam.position">
                <a-select-option value>请选择</a-select-option>
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="设备类型">
              <a-select placeholder="请选择类型" v-model="queryParam.type">
                <a-select-option value>请选择</a-select-option>
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left; overflow: hidden">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator" style="border-top: 5px">
      <a-row :gutter="24">
        <a-col :md="14" :sm="12">
          <a-button @click="handleAdd" icon="plus" type="primary">新建</a-button>
          <!-- <a-button @click="handleExportXls('用户信息')" icon="download">下载</a-button> -->
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu @click="handleMenuClick" slot="overlay">
              <a-menu-item key="1">
                <a-icon @click="batchDel" type="delete" />删除
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <a-upload
            :action="importExcelUrl"
            :headers="tokenHeader"
            :multiple="false"
            :show-upload-list="false"
            @change="handleImportExcel"
            name="file"
          >
            <a-button icon="import">数据导入</a-button>
          </a-upload>
        </a-col>
        <a-col :md="10" :sm="12" class="flex justify-end">
          <a-radio-group @change="handleRadioChange" buttonStyle="solid" v-model="checkoutBtn">
            <a-radio-button :value="0">所有设备</a-radio-button>
            <a-radio-button :value="1">重点设备</a-radio-button>
            <a-radio-button :value="2">一般设备</a-radio-button>
          </a-radio-group>
        </a-col>
        <!-- <div class="w-full h-48 overflow-auto">121212</div> -->
      </a-row>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
        bordered
        ref="table"
        row-key="id"
        size="middle"
      >
        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <!-- <a-avatar :src="getAvatarView(record.avatar, index)" icon="user" shape="square" /> -->
            {{ record.avatar }},{{ index }}
          </div>
        </template>
        <template slot="status" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <!-- <a-avatar :src="getAvatarView(record.avatar, index)" icon="user" shape="square" /> -->
            {{ record.status }},{{ index }}
          </div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)" href="javascript:;">查看</a>
        </span>
      </a-table>
    </div>
    <account-edit-modal @ok="modalFormOk" ref="modalForm"></account-edit-modal>
  </a-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AccountEditModal from './modules/AccountEdit'

  export default {
    name: 'EquipmentAccount',
    components: { AccountEditModal },
    mixins: [JeecgListMixin],
    // 定义属性
    data () {
      return {
        checkoutBtn: 0,
        queryParam: {
          username: ''
        },
        columns: [
          {
            title: '位号',
            align: 'center',
            dataIndex: 'username',
            width: 120,
            sorter: true
          },
          {
            title: '设备名称',
            align: 'center',
            width: 100,
            dataIndex: 'realname'
          },
          {
            title: '设备类型',
            align: 'center',
            width: 120,
            dataIndex: 'avatar',
            scopedSlots: { customRender: 'avatarslot' }
          },

          {
            title: '设备型号',
            align: 'center',
            width: 80,
            dataIndex: 'sex_dictText',
            sorter: true
          },
          {
            title: '状态',
            align: 'center',
            width: 100,
            dataIndex: 'birthday'
          },
          {
            title: '供水流域',
            align: 'center',
            width: 100,
            dataIndex: 'phone'
          },
          {
            title: '供水流域',
            align: 'center',
            width: 180,
            dataIndex: 'orgCodeTxt'
          },
          {
            title: '资产属性',
            align: 'center',
            width: 180,
            dataIndex: 'departIds_dictText'
          },
          {
            title: '运行状态',
            align: 'center',
            width: 80,
            dataIndex: 'serviceStatus',
            scopedSlots: { customRender: 'status' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: 'center',
            width: 170
          }
        ],
        url: {
          syncUser: '/act/process/extActProcess/doSyncUser',
          list: '/device/devList/list',
          delete: '/sys/user/delete',
          deleteBatch: '/sys/user/deleteBatch',
          exportXlsUrl: '/sys/user/exportXls',
          importExcelUrl: 'sys/user/importExcel'
        }
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () { },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () { },
    // 方法集合
    methods: {
      // 批量操作
      handleMenuClick (e) {
        if (e.key === 1) {
          this.batchDel()
        } else if (e.key === 2) {
          this.batchFrozen(2)
        } else if (e.key === 3) {
          this.batchFrozen(1)
        }
      },
      // handleEdit
      handleDetail (record) {
        this.$router.push({
          path: '/equipment/account/detail',
          query: {
            accountId: record.id
          }
        })
      },
      handleRadioChange (e) {
        this.checkoutBtn = e.target.value
      }
    }
  }
</script>

<style lang="less" scoped></style>
